export default __webpack_public_path__ + "static/media/lady.25c84b06.png";